import { FormattedMessage } from 'react-intl';

import { facet } from '@app/components';
import { DateRange, getDateRangeOptions } from '@app/utils';
import { dateFiltersMessages } from '@app/translations';

export const getDateRangeLabel = ({
  minDate = '',
  maxDate = '',
}: DateRange) => {
  const { invertedOptions: invertedDateRangeOptions } = getDateRangeOptions();

  if (minDate && maxDate) {
    return (
      <FormattedMessage
        {...dateFiltersMessages.range}
        values={{
          minYear: minDate,
          maxYear: maxDate,
        }}
      />
    );
  }

  if (invertedDateRangeOptions[minDate]) {
    return (
      <FormattedMessage
        {...dateFiltersMessages[invertedDateRangeOptions[minDate]]}
      />
    );
  }

  if (minDate) {
    return (
      <FormattedMessage
        {...dateFiltersMessages.from}
        values={{
          minYear: minDate,
        }}
      />
    );
  }

  if (maxDate) {
    return (
      <FormattedMessage
        {...dateFiltersMessages.to}
        values={{
          maxYear: maxDate,
        }}
      />
    );
  }

  return '';
};

export const getShouldMapFacetLabel = facetKey => {
  const facetsToMapLabel = [facet.status, facet.location, facet.language];

  return facetsToMapLabel.includes(facetKey);
};
